
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WebsiteComposite } from '@/services/Website/interfaces';

@Component
export default class SubdomainCreatePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  public prefix = '';

  public installWp = false;

  public enableMail = false;

  private readonly PREFIX_REGEX = /^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/;

  public get parentDomain(): string {
    return this.composite.website.domain;
  }

  public get prefixRules(): Array<(value: string) => boolean | string> {
    return [
      (value: string) => !!value.trim() || 'Subdomain is required',
      (value: string) => this.PREFIX_REGEX.test(value.trim()) || 'Invalid subdomain',
    ];
  }

  public get valid(): boolean {
    return this.PREFIX_REGEX.test(this.prefix.trim());
  }

  public onSubmit(): void {
    if (!this.valid) {
      return;
    }

    const excludeActions: string[] = [];
    if (!this.installWp) {
      excludeActions.push('wp', 'db');
    }
    if (!this.enableMail) {
      excludeActions.push('email');
    }

    this.$emit('submit', {
      domain: `${this.prefix.trim()}.${this.parentDomain}`,
      excludeActions,
    });
  }
}
